// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__8uKac","header":"styles_header__2FyoQ","button":"styles_button__3J07n","forgot":"styles_forgot__hA6uz"};